import { get } from '../../json-transform';

export const PaginationSchema = {
  page: get('page').asInt().ifNaN(undefined),
  size: get('page_size').asInt().ifNaN(undefined),
};
